import UiIcon from "@/components/ui/icons/icon";
import { WhiteCard } from "./white.card";
import { ArrowUpRight, ArrowDownLeft } from "lucide-react";
import { thousandSeparator } from "@/utils";

interface StatCardItemProps {
  title: string;
  value: string;
  direction?: "up" | "down";
  evolution?: string;
}
export function StatCardItem({
  title,
  value,
  evolution,
  direction = "up",
}: StatCardItemProps) {
  return (
    <div className="stats-card-item">
      <div className="stats-card-item-value">{thousandSeparator(value)}</div>
      <div className="stats-card-item-title">{title}</div>
      <div className="stats-card-item-evolution pt-2">
        <span className="stats-card-item-evolution-icon">
          <UiIcon>
            {direction === "up" && <ArrowUpRight size={20} color="#34C759" />}
            {direction === "down" && (
              <ArrowDownLeft size={20} color="#FF3B30" />
            )}
          </UiIcon>
        </span>
        <span className="stats-card-item-evolution-value">{evolution}</span>
      </div>
    </div>
  );
}

interface StatsCardProps {
  children: React.ReactNode;
}
export function StatsCard({ children }: StatsCardProps) {
  return <WhiteCard className="dashboard-stats-card">{children}</WhiteCard>;
}
